import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { BaseCta } from './BaseCta';

export const BaseCtaWithLink = ({ children, className, classOptions, to, ...otherProps }) => (
  <BaseCta className={className} classOptions={classOptions} tag={Link} to={to} {...otherProps}>
    {children}
  </BaseCta>
);

BaseCtaWithLink.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  classOptions: PropTypes.object,
  to: PropTypes.string,
};
